var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 23 23"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.5 23C5.159 23 0 17.841 0 11.5S5.159 0 11.5 0 23 5.159 23 11.5 17.841 23 11.5 23m0-22C5.71 1 1 5.71 1 11.5S5.71 22 11.5 22 22 17.29 22 11.5 17.29 1 11.5 1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 16.5a.5.5 0 0 1-.354-.146l-5-5a.5.5 0 0 1 .707-.707L10 15.293l7.646-7.646a.5.5 0 0 1 .707.707l-8 8A.5.5 0 0 1 10 16.5"
})));
export default SvgSuccess;